import { lazy } from 'react';

// Lazy load the components
const ListingPage = lazy(() => import('../pages/ListingPage'));
const Home = lazy(() => import('../pages/market/MarketPage'));
const CustomLayout = lazy(() => import('../components/Layouts/CustomLayout'));

export const wlRoutes = [
  {
    element: <CustomLayout />,
    children: [
      { path: 'business/:businessId/properties/:id', element: <ListingPage /> },
      {
        path: 'homes/business/:businessId/:country/:city/:title/:id',
        element: <ListingPage />,
      },
      { path: 'business/:businessId/market', element: <Home /> },
    ],
  },
];
